/** Sponsored banner insertion points in the product grid (unchanged behavior). */
export function getSearchBannerSlots(isDesktop: boolean) {
  const cols = isDesktop ? 4 : 1;
  const fallbackRows = isDesktop ? 2 : 4;
  const rows = fallbackRows;
  const itemsPerBanner = rows * cols;

  const slotsRaw = [
    { position: "search-1" },
    { position: "search-2" },
    { position: "search-3" },
  ];
  const positions = slotsRaw
    .map((s) => String(s?.position || "").trim())
    .filter(Boolean)
    .slice(0, 3);

  return positions.map((position, idx) => ({
    after: itemsPerBanner * (idx + 1),
    position,
  }));
}
